module.exports = __webpack_public_path__ + "static/worg-46a49fc56cbb44178e5f14fc9628feab.jpg";